<template>
    <v-container class="py-8">
        <v-card>
             <v-subheader><h2>Notification History <v-btn icon @click='getUserTasks()'>
        <v-icon title='refresh the list' >refresh</v-icon>
      </v-btn>
</h2></v-subheader>
           
            <v-text-field
            class='ma-4'
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
      
                 <v-data-table
    
    :loading="notificationLoading"
    :headers="headers"
    :items="queueMessage"
    item-key="name"
    class="elevation-1"
  >
     <template v-slot:item.userEmail="{ item }">
           <a @click='$router.push("/user/email/"+item.userEmail)'>{{item.userEmail}}</a>
          </template>
  <template v-slot:item.content="{ item }">
   
   
    <a v-if='item.type === "Health history update" || item.type === "Family history update"' @click='modal=true; formatContent(item.content)'>click to see details</a>
     <span v-else>{{item.content}}</span>
    </template>

     <template v-slot:item.action="{ item }">
        <v-icon
        title='recover task'
        color='green'
        class="mr-2"
       @click='recoverTask(item)'
      >
        check
      </v-icon>
    </template>

  </v-data-table>
           
        </v-card>
        </v-container>
</template>

<script>
import { mapFields } from 'vuex-map-fields';
import { postReq } from '../helper/firestore'
export default {
    data() {
        return {
            notificationLoading : true,
             search: '',
            queueMessage : [],
              headers : [
         { text: 'User email', value: 'userEmail' },
         { text: 'Time', value: 'time' },
        { text: 'Notification Type', value: 'type' },
            { text: 'Description', value: 'content' },
            { text: 'Action',value: 'action'}
      ],
        }
    },
    methods: {
           recoverTask(item){
      postReq(process.env.VUE_APP_ROOT_API_URL + 'api/admin/updateTaskStatus', { idToken: this.user.idToken, taskId: item.id,requestType: "open"}, result => {
            if (result.status !== 200) { return }
        this.getUserTasks()
        })
    },
      getUserTasks(){
      this.notificationLoading = true;
          postReq(process.env.VUE_APP_ROOT_API_URL + 'api/admin/getmytasks', { gcid:this.user.uid,requestType:'closed'}, result => { 
            if (result.status !== 200) { return }

            this.queueMessage = result.data
            this.notificationLoading = false;
    })
    },
    },


    mounted() {
            this.getUserTasks()

    },
    computed: {
        ...mapFields([
            'user',
        ]),
    }
}
</script>

<style>

</style>
